import { makeStyles } from '@material-ui/styles'

export default makeStyles((theme) => ({
  textBlack: {
    color: 'black',
  },
  textGray: {
    color: '#707182',
  },
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
  firstSection: {
    background: 'white',
    borderRadius: '5px',
    boxShadow: '0 1px 5px 0 rgba(227, 227, 236, 0.8)',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  firstSectionFirstSubSection: {
    padding: theme.spacing(2, 2),
  },
  firstSectionSecondSubSection: {
    padding: theme.spacing(2, 2),
  },
  sectionTitle: {
    fontWeight: 'bold',
  },
  sectionBottomBorder: {
    borderBottom: '3px solid #f4f6fe',
  },
  secondSection: {
    background: 'white',
    borderRadius: '5px',
    boxShadow: '0 1px 5px 0 rgba(227, 227, 236, 0.8)',
    marginBottom: theme.spacing(2),
  },
  secondSectionFirstSubSection: {
    borderBottom: '3px solid #f4f6fe',
    padding: theme.spacing(2, 2),
  },
  linkButton: {
    textTransform: 'capitalize',
  },
  selector: {
    width: '100%',
    paddingRight: theme.spacing(2),
  },
  greenText: {
    color: 'green',
  },
  orangeText: {
    color: 'orange',
  },
  assessmentItem: {
    padding: theme.spacing(1, 0),
  },
  assessmentPhoto: {
    width: 120,
  },
  itemPhoto: {
    width: 120,
    cursor: 'pointer',
  },
  parentParentItemTitle: {
    padding: theme.spacing(1, 2),
  },
}))
